import { createSlice } from "@reduxjs/toolkit";
import { getUserPokemons } from "../reducers/getUserPokemons";
import {
  PokemonInitialStateType,
  generatedPokemonType,
} from "../../utils/types";
import { loadLocalList, saveLocalList, clearLocalList } from "../../utils/listStorage";

const initialState: PokemonInitialStateType = {
  compareQueue: [],
  userPokemons: loadLocalList(),
  currentPokemon: undefined,
};

export const PokemonSlice = createSlice({
  name: "pokemon",
  initialState,
  reducers: {
    addToCompare: (state, action) => {
      const exists = state.compareQueue.some(
        (p: generatedPokemonType) => p.id === action.payload.id
      );
      if (exists) return;
      if (state.compareQueue.length === 2) state.compareQueue.pop();
      state.compareQueue.unshift(action.payload);
    },
    removeFromCompare: (state, action) => {
      state.compareQueue = state.compareQueue.filter(
        (p: generatedPokemonType) => p.id !== action.payload.id
      );
    },
    setCurrentPokemon: (state, action) => {
      state.currentPokemon = action.payload;
    },
    addToUserPokemonList: (state, action) => {
      const exists = state.userPokemons.some(
        (p: generatedPokemonType) => p.id === action.payload.id
      );
      if (!exists) {
        state.userPokemons.push(action.payload);
        saveLocalList(state.userPokemons);
      }
    },
    removeFromUserPokemonList: (state, action) => {
      state.userPokemons = state.userPokemons.filter(
        (p: generatedPokemonType) => p.id !== action.payload.id
      );
      saveLocalList(state.userPokemons);
    },
    clearUserPokemons: (state) => {
      state.userPokemons = [];
      clearLocalList();
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserPokemons.fulfilled, (state, action) => {
      state.userPokemons = action.payload!;
      saveLocalList(state.userPokemons);
    });
  },
});

export const {
  addToCompare,
  removeFromCompare,
  setCurrentPokemon,
  addToUserPokemonList,
  removeFromUserPokemonList,
  clearUserPokemons,
} = PokemonSlice.actions;
